// extracted by mini-css-extract-plugin
export default {"price":"O6-z","onSale":"P6-z","msrpLabelPrice":"Q6-z","msrpLabel":"R6-z","originalPrice":"S6-z","percentOff":"T6-z"};